export const SAVING_ERROR_MESSAGE = {
  header: 'Something went wrong',
  message: 'We encountered an issue while processing your request. Please try again later.',
};
export const OPENING_ERROR_MESSAGE = {
  header: 'Under Maintenance',
  message: 'The Photo Editor is currently unavailable. Please try again later.',
};
